import { Injectable } from '@angular/core';
import { Router,CanActivate } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate()
  {
    if (localStorage.getItem('accessToken'))
    {
      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page
    localStorage.clear();
    this.router.navigate(['/login']);
    return false;
  }
  
}
